import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ProjectModel } from '@/libs/Api';
import { ProjectsDataService } from '@/libs/projects/projects-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const projectsStore = registerCrudStore<ProjectModel, ProjectModel>(BusinessModule.Project, new ProjectsDataService());
